<template>
  <div class="bl-client-task">
    <!-- 1st tab -->
    <div
      class="flex flex-col flex-grow-0 flex-shrink-0 w-3/12 h-full gap-2 px-2 py-2"
    >
      <custom-search-bar
        :name="'search-task'"
        :value="currentQuery"
        :placeholder="'Search'"
        v-on:update:value="onSearch($event)"
        class="flex-shrink-0 w-full h-10"
      />
      <div
        class="flex items-center flex-shrink-0 w-full h-10 gap-2 px-5 text-sm text-white rounded cursor-pointer bg-primary hover:bg-primary3"
        @click="showModal"
      >
        <i class="fas fa-plus"></i>
        <div class="font-medium">Add Task</div>
      </div>
      <div class="flex items-center flex-shrink-0 h-5">
        <div class="text-sm font-medium">
          Showing All Results - {{ totalTasks }} Task(s)
        </div>
      </div>
      <div
        class="pr-2 overflow-auto"
        :style="{
          height:
            'calc(100vh - 4.5rem - 1rem - 2.5rem - 2.5rem - 1.25rem - 1.5rem - 0.5rem)'
        }"
      >
        <div
          v-if="fetchLoading"
          class="flex items-center justify-center w-full h-full"
        >
          <div class="blum-loader"></div>
        </div>
        <div
          v-else-if="!tasks.length"
          class="flex items-center justify-center w-full h-full"
        >
          <div class="text-placeholder">No Task.</div>
          <div
            class="px-2 font-medium cursor-pointer text-primary"
            @click="showModal"
          >
            Add New
          </div>
        </div>
        <div v-else class="flex flex-col gap-2">
          <div
            v-for="task in tasks"
            :key="task.id"
            class="relative w-full transition-all duration-300 border rounded cursor-pointer hover:bg-hover-state"
            :class="[
              selectedTask && task.id === selectedTask.id
                ? 'border-primary'
                : 'border-transparent'
            ]"
            @click="showDetail(task)"
          >
            <div
              class="flex items-start justify-between px-6 py-4 rounded"
              :style="{ borderBottom: `6px solid ${task.curriculum_color}` }"
            >
              <div class="flex flex-col gap-1">
                <div class="text-xs font-medium">
                  {{ task.curriculum_name }}
                </div>
                <div class="text-sm font-medium">{{ task.name }}</div>
              </div>
              <div
                v-popover.left="{ name: `remove-task-${task.id}` }"
                class="px-2 text-xs text-right text-gray-600 cursor-pointer"
              >
                <i class="fas fa-ellipsis-v"></i>
              </div>
              <popover
                :name="`remove-task-${task.id}`"
                :width="128"
                :pointer="false"
                class="absolute right-8 top-12"
              >
                <div
                  class="px-2 py-1 cursor-pointer hover:bg-hover-state"
                  @click="removeTask(task)"
                >
                  Delete
                </div>
              </popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end 1st tab -->

    <!-- 2nd tab -->
    <div class="flex flex-shrink-0 w-9/12 h-full px-2 py-2">
      <div class="w-full px-6 py-6 rounded bg-box">
        <div class="h-6 font-medium">Goals</div>
        <div :style="{ height: 'calc(100vh - 4.5rem - 1rem - 3rem - 1.5rem)' }">
          <div v-if="showLoading" class="grid h-full place-items-center">
            <div class="blum-loader"></div>
          </div>
          <div
            v-else-if="!tasks.length || selectedTask === null"
            class="flex items-center justify-center w-full h-full"
          >
            <div v-if="!tasks.length" class="flex items-center gap-2">
              <div class="text-placeholder">No Task.</div>
              <div
                class="px-2 font-medium cursor-pointer text-primary"
                @click="showModal"
              >
                Add Task
              </div>
            </div>
            <div v-else class="flex items-center gap-2">
              <div class="text-placeholder">No Goals.</div>
              <div
                class="px-2 font-medium cursor-pointer text-primary"
                @click="showDetail(tasks[0])"
              >
                Select Task
              </div>
            </div>
          </div>
          <TaskGoals
            v-else
            :selectedTask="selectedTask"
            :curriculumOptions="curriculumOptions"
          />
        </div>
      </div>
    </div>
    <!-- end 2nd tab -->

    <modal
      name="add-task-modal"
      class="overflow-auto"
      :height="'auto'"
      :minWidth="800"
      :adaptive="true"
    >
      <div class="px-8 py-8">
        <div class="flex items-center justify-between mb-8">
          <div class="text-xl font-bold font-logo">New Task</div>
          <div class="px-2 text-right cursor-pointer" @click="hideModal">
            <i class="fas fa-times"></i>
          </div>
        </div>
        <form @submit.prevent="addTask" class="grid gap-24">
          <div class="grid gap-4">
            <BlInputText :input="nameInput" @changed="inputHandler" />
            <BlSelectBox
              label="Curriculum"
              asterisk
              search
              v-model="curriculumIdInput"
              placeholder="Select curriculum"
              :options="curriculumOptions"
              @change="curriculumIdInput = $event"
            />
            <BlInputText :input="descriptionInput" @changed="inputHandler" />
          </div>
          <button
            type="submit"
            class="px-6 py-2 text-sm font-medium text-white rounded bg-primary hover:bg-primary3"
            :class="{ 'cursor-wait': submitLoading }"
          >
            Save
          </button>
        </form>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import TaskGoals from "@/components/clients/TaskGoals.vue";
import BlSelectBox from "../BlSelectBox.vue";
import BlInputText from "../BlInputText.vue";
//
import CustomSearchBar from "../CustomSearchBar.vue";
import CustomInput from "../CustomInput.vue";
import CustomSelect from "../CustomSelect.vue";

export default {
  name: "ClientTask",
  components: {
    TaskGoals,
    BlSelectBox,
    BlInputText,
    //
    CustomSearchBar,
    CustomInput,
    CustomSelect
  },
  props: ["id"],
  data() {
    return {
      currentQuery: "",
      fetchLoading: true,
      submitLoading: false,
      showLoading: false,
      //
      nameInput: {
        label: "Title",
        placeholder: "Type title task",
        model: "",
        asterisk: true
      },
      curriculumIdInput: "",
      descriptionInput: {
        label: "Description",
        placeholder: "Type description task",
        model: "",
        textarea: true,
        asterisk: true
      },
      //
      selectedTask: null
    };
  },
  computed: {
    ...mapGetters(["curriculums", "tasks", "task"]),
    totalTasks() {
      return this.tasks.length;
    },
    curriculumOptions() {
      return this.curriculums.map(curriculum => ({
        value: curriculum.id,
        label: curriculum.name,
        prefixColor: curriculum.color
      }));
    }
  },
  created() {},
  async mounted() {
    await this.getCurriculums({ params: "?sort=name_asc" });
    this.refresh();
  },
  methods: {
    ...mapActions([
      "getCurriculums",
      "getTasks",
      "getTask",
      "createTask",
      "updateTask",
      "deleteTask",
      "getSteps",
      "getRoutines"
    ]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    //
    async refresh() {
      const params = { id: this.id, params: "" };
      if (this.currentQuery) params.params += `?query=${this.currentQuery}`;

      this.fetchLoading = true;
      await this.getTasks(params);
      this.fetchLoading = false;
    },
    onSearch(text) {
      this.currentQuery = text;
      this.refresh();
      if (text) return this.setAlert("info", "Searching: " + text);
    },
    showModal() {
      this.$modal.show("add-task-modal");
    },
    hideModal() {
      this.nameInput.model = "";
      this.curriculumIdInput = "";
      this.descriptionInput.model = "";
      this.$modal.hide("add-task-modal");
    },
    async addTask() {
      if (this.submitLoading) return;

      if (!this.nameInput.model) {
        return this.setAlert("error", "Title should not be empty");
      }
      if (!this.curriculumIdInput) {
        return this.setAlert("error", "Curriculum should not be empty");
      }
      if (!this.descriptionInput.model) {
        return this.setAlert("error", "Description should not be empty");
      }
      const params = {
        id: this.id,
        params: {
          name: this.nameInput.model,
          curriculum_id: this.curriculumIdInput,
          description: this.descriptionInput.model
        }
      };
      this.submitLoading = true;
      const {success, data} = await this.createTask(params);
      this.submitLoading = false;
      if (!success) return
      this.showDetail(data)
      this.hideModal();
    },
    removeTask(task) {
      if (confirm("Are you sure you want to delete this task?")) {
        this.deleteTask(task);
      }
    },
    async showDetail(task) {
      this.showLoading = true;
      const { success, data } = await this.getTask(task);
      if (!success) return;
      await this.getSteps(task);
      await this.getRoutines(task);
      this.selectedTask = data;
      this.showLoading = false;
    },
    setAlert(type, text) {
      this.$toasted.show(text, { type: type });
    }
  }
};
</script>

<style scoped lang="scss">
.bl-client-task {
  position: relative;
  width: calc(100vw - 0.5rem);
  height: calc(100vh - 4.5rem);
  padding: 0 1.5rem;
  box-sizing: border-box;
  background: var(--background-depth-one-color);
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/clients/ClientTask.vue